/* import __COLOCATED_TEMPLATE__ from './email.hbs'; */
var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { assertInstanceOf } from '@banking/ui/utils/assert';
const VALID_INPUT = /^(\s*|\d+)$/;
let Email = (_class = class Email extends Component {
  // FIXME(cvu): Change any to unknown and type-narrow
  onCodeChange(event) {
    const value = assertInstanceOf(event, CustomEvent).detail.value;
    if (!VALID_INPUT.test(value)) {
      event.preventDefault();
      return;
    }
    this.args.onConfirmationCodeChange(value);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "onCodeChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCodeChange"), _class.prototype)), _class);
export { Email as default };